import { lazy } from "react"
import {
  CLAN_ALTAR_BONUS,
  IClanAltarInstance
} from "store/apis/clanAltarAPI/types"
import {
  CLAN_BUILDING_TYPE,
  CLAN_ROLE,
  IClan,
  IClanBuildingInstance,
  IClanRequest,
  IClanTax,
  IMember
} from "store/apis/clansAPI/types"

export const CLAN_MODALS = {
  moderateClanMember: {
    component: lazy(() => import("modals/ui/clan/clan-member-moderate")),
    params: {} as {
      member: IMember
      clan: IClan
      role: CLAN_ROLE
    }
  },
  clanBuildingModal: {
    component: lazy(() => import("modals/ui/clan/clan-building-modal")),
    params: {} as {
      clanId?: string
      building: IClanBuildingInstance | IClanAltarInstance
      role: CLAN_ROLE
    }
  },
  addBuildingModal: {
    component: lazy(() => import("modals/ui/clan/clan-add-building-modal")),
    params: {} as {
      clanId: string
      buildingType: CLAN_BUILDING_TYPE
      role: CLAN_ROLE
    }
  },
  applicationModal: {
    component: lazy(() => import("modals/ui/clan/clan-application-modal")),
    params: {} as {
      clan: IClan
      onSend: (message: string, isPrivate?: boolean) => Promise<void>
    }
  },
  deleteClanModal: {
    component: lazy(() => import("modals/ui/clan/clan-delete-modal"))
  },
  approveRequestModal: {
    component: lazy(() => import("modals/ui/clan/clan-approve-request-modal")),
    params: {} as {
      request: IClanRequest
      clan: IClan
    }
  },
  leaveClan: {
    component: lazy(() => import("modals/ui/clan/clan-leave-modal"))
  },
  clanTaxModal: {
    component: lazy(() => import("modals/ui/clan/clan-tax-modal")),
    params: {} as {
      tax: IClanTax
    }
  },
  clanGuideModal: {
    component: lazy(() => import("modals/ui/clan/clan-guide-modal"))
  },
  clanInfoModal: {
    component: lazy(() => import("modals/ui/clan/clan-info-modal"))
  },
  altarPayerBuff: {
    component: lazy(() => import("modals/ui/clan/altar-payer-buff-modal")),
    params: {} as {
      slotId: string
    }
  },
  altarClanBuff: {
    component: lazy(() => import("modals/ui/clan/altar-clan-buff-modal")),
    params: {} as {
      type: CLAN_ALTAR_BONUS
    }
  },
  altarHowItWorks: {
    component: lazy(() => import("modals/ui/clan/altar-howItWorks"))
  },
  clanMinPower: {
    component: lazy(() => import("modals/ui/clan/clan-min-power-modal")),
    params: {} as {
      clan: IClan
    }
  }
} as const
